import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Label,
  Row,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "reactstrap";
import React, { useState, useContext } from "react";
import { Fragment } from "react";
import PropTypes from "prop-types";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import { faFilter, faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import {
  DeleteDebtReceivable,
  fetchDebtsReceivable,
  fetchDebtsToPayProvider,
} from "../../helpers/api/finance";
import { isIterableArray } from "../../helpers/utils";
import FullPagination from "../common/pagination/FullPagination";
import DebtToPayListItem from "../common/DebtToPayListItem";
import { useSelector } from "react-redux";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "./../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { Link, useHistory } from "react-router-dom";
import { Or, PreloadState } from "../UI/preloading/PreloadState";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SupportLink from "../root/support/components/SupportLink";
import NumberFormat from "react-number-format";
import moment from "moment";
import { fetchProperties } from "../../helpers/api/condominium";
import Avatar from "../common/Avatar";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const Receivable = ({ setRedirect, setRedirectUrl, showPagination = true }) => {
  const moduleBase = useModuleBase();
  const { id } = useParams();
  const history = useHistory();

  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { baseCurrency } = useContext(CurrencyContext);

  const [formDate, setformDate] = useState({ since: null, to: null });
  const [params, setParams] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const {
    data,
    error,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchProperties, params);

  const ButtonAdd = ({ onClick }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus}>
        Añadir cuenta
      </ButtonIcon>
    );
  };

  console.log(data);

  const handleCreateDebtToPay = () => {
    setRedirect(true);
    setRedirectUrl(`/dashboard/${moduleBase}/${id}/receivable/create`);
  };

  console.log(data);

  const handleDelete = async (receivableId) => {
    try {
      const { code } = await DeleteDebtReceivable(receivableId);
      if (code === SUCCESS_RESPONSE.OK) {
        setRedirect(true);
        setRedirectUrl(`/dashboard/finance`);
        Toast.fire({
          type: "success",
          title: `Efecto por cobrar borrado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const renderDebts = () => {
    return data.map((debt) => {
      return (
        <DebtToPayListItem
          key={debt.id}
          avatar={"https://picsum.photos/200/200"}
          id={debt.id}
          receivable={true}
          title={debt.name}
          price={debt.price}
          description={debt.description}
          expires_at={debt.expires_at}
          debtToPayId={debt.id}
          onDeleteAction={() => handleDelete(debt.id)}
          onEditAction={() => {
            setRedirect(true);
            setRedirectUrl(
              `/dashboard/${moduleBase}/${
                id ? id : selectedCondominium
              }/receivable/detail/${debt.id}`
            );
          }}
          alternativeName={"Efecto por cobrar"}
          createdAt={debt.created_at}
          options={true}
        />
      );
    });
  };

  return (
    <Fragment>
      <PageHeader
        title="Efectos por cobrar"
        titleTag="h2"
        description="Gestiona y administra cada una de tus finanzas."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Fragment>
        <Card>
          <FalconCardHeader title="Efectos por cobrar">
            <Row className="justify-content-end">
              <Col xs="auto">
                <Row className="justify-content-center mb-3">
                  <Col
                    xs="auto"
                    lg="auto"
                    md={12}
                    sm={12}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <Label className="mb-0 mr-2">
                      <FontAwesomeIcon icon={faFilter} />
                    </Label>
                  </Col>
                  <Col
                    xs="auto"
                    sm="auto"
                    lg="auto"
                    className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                  >
                    <Label className="mr-2 mb-0">Desde</Label>
                    <Datetime
                      value={formDate.since}
                      isValidDate={(current, selected) => {
                        return !current.isAfter();
                      }}
                      onChange={(d) =>
                        setformDate((prev) => ({ ...prev, since: d }))
                      }
                      dateFormat="DD/MM/YYYY"
                      timeFormat={false}
                    />
                  </Col>
                  <Col
                    xs="auto"
                    sm="auto"
                    lg="auto"
                    className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                  >
                    <Label className="mr-2 mb-0">Hasta</Label>
                    <Datetime
                      value={formDate.to}
                      className="mr-2"
                      isValidDate={(current, selected) => {
                        return (
                          current.isAfter(formDate.since) && !current.isAfter()
                        );
                      }}
                      dateFormat="DD/MM/YYYY"
                      timeFormat={false}
                      onChange={(d) =>
                        setformDate((prev) => ({ ...prev, to: d }))
                      }
                    />
                  </Col>
                  <Col
                    xs="auto"
                    className="pl-0 d-flex align-items-md-end align-items-lg-center align-items-sm-end"
                  >
                    <ButtonIcon
                      className="text-nowrap d-sm-none d-lg-block"
                      disabled={!formDate.to ? true : false}
                      icon={faSearch}
                      color="falcon-default"
                      onClick={() => {
                        setParams((prev) => {
                          return {
                            ...prev,
                            start_date: formDate.since.format("YYYY-MM-DD"),
                            end_date: formDate.to.format("YYYY-MM-DD"),
                          };
                        });
                      }}
                    >
                      Buscar
                    </ButtonIcon>
                    <Button
                      className="text-nowrap d-sm-block d-lg-none"
                      disabled={!formDate.to ? true : false}
                      color="falcon-default"
                      onClick={() => {
                        setParams((prev) => {
                          return {
                            ...prev,
                            start_date: formDate.since.format("YYYY-MM-DD"),
                            end_date: formDate.to.format("YYYY-MM-DD"),
                          };
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </FalconCardHeader>
          <CardBody className="fs--1 p-0">
            <PreloadState cond={isIterableArray(data)} loading={isLoading}>
              {data ? (
                <>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th className="w-auto align-middle"></th>
                        <th className="text-center align-middle">DNI</th>
                        <th width="35%" className="align-middle">
                          Usuario y nombre
                        </th>
                        <th className="align-middle">N° de teléfono</th>
                        <th width="10%" className="text-center align-middle">
                          Opciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((property, index) => (
                        <Fragment key={index}>
                          <tr>
                            <td className="w-auto text-center">
                              <Avatar
                                src={
                                  property?.user?.data?.image
                                    ? import.meta.env.VITE_URL +
                                      "/storage/" +
                                      property?.user?.data?.image
                                    : undefined
                                }
                              />
                            </td>
                            <td className="align-middle text-center">
                              {property?.user?.data?.dni
                                ? property?.user?.data?.dni
                                : "Documento no registrado"}
                            </td>
                            <td className="align-middle">
                              <b>
                                {" "}
                                {`${property?.user?.username}`}
                              </b>{" "}
                              |{" "}
                              {`${property?.user?.data?.firstname} ${property?.user?.data?.lastname}`}
                            </td>
                            <td className="align-middle">
                              {property?.user?.data?.phone
                                ? property?.user?.data?.phone
                                : "Télefono no registrado"}
                            </td>
                       
                            <td className="text-center align-middle">
                              <UncontrolledDropdown
                                direction="left"
                                className="d-inline-block ml-2"
                              >
                                <DropdownToggle
                                  color="falcon-default"
                                  size="sm"
                                >
                                  <FontAwesomeIcon icon="ellipsis-h" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    onClick={() =>
                                      history.push({
                                        pathname: `/dashboard/${moduleBase}/${id}/receivable/${property.id}`, state: {
                                          debt: property,
                                      }
                                      })
                                    }
                                  >
                                    Ver detalles
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>

                          {/*       <Col className=" shadow-none border-top">
                        <Row className="mb-3 mt-3">
                          <Col className="d-flex align-items-center">
                            <div className="media-body">
                              <h6 className="mb-0 font-weight-semi-bold">
                                <span className="text-900">
                                  <p className="m-0">
                                  {`${property?.user?.data?.firstname} ${property?.user?.data?.lastname}`}
                                  </p>
                                </span>
                              </h6>
                              <p className="m-0">
                              {property?.user.data.phone}
                              </p>
                              <p className="m-0">
                                creada el{" "}
                                {moment(property?.user.created_at).format("DD-MM-YYYY")}
                              </p>
                            </div>
                          </Col>
                          <Col>
                            <Row>
                              <Col>
                                <p className="text-right">Monto</p>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <h5 className="text-right">
                                  <NumberFormat
                                    prefix={`${baseCurrency.symbol} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    displayType="text"
                                    value={10}
                                  />
                                </h5>
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            xs="auto"
                            className="d-sm-flex align-items-center"
                          >
                            <UncontrolledDropdown
                              direction="left"
                              className="d-inline-block ml-2"
                            >
                              <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem
                                  onClick={() =>
                                    history.push({
                                      pathname: `/dashboard/${moduleBase}/${id}/receivable/${property.user.id}`,
                                    })
                                  }
                                >
                                  Ver detalles
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </Col>
                        </Row>
                      </Col> */}
                        </Fragment>
                      ))}
                    </tbody>
                  </Table>
                </>
              ) : (
                <Row className="p-card">
                  <Col>
                    <Alert color="info" className="mb-0">
                      Al parecer aún no hay cuentas para mostrar. Puedes crear
                      una ahora mismo pulsando el siguiente enlace
                      <Button
                        data-testid="Button"
                        tag={Link}
                        color="link"
                        size="sm"
                        className="ml-1 pl-0"
                        to={`/dashboard/${moduleBase}/${selectedCondominium}/common-costs/create`}
                      >
                        Crear gasto comun
                      </Button>
                    </Alert>
                  </Col>
                </Row>
              )}
              {showPagination && (
                /*      <CardFooter className="border-top"> */
                <FullPagination
                  nextPage={nextPage}
                  prevPage={previousPage}
                  goToPage={goToPage}
                  meta={meta}
                  className={"shadow-none"}
                  posText={"Efectos por cobrar"}
                  perPage={perPage}
                />
                /*       </CardFooter> */
              )}
            </PreloadState>
          </CardBody>
        </Card>
      </Fragment>
    </Fragment>
  );
};

Receivable.propTypes = {
  showPagination: PropTypes.bool,
};

export default withRedirect(Receivable);
